import CloseIcon from '@mui/icons-material/Close';
import { Button, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';
import { CustomDialogTitle } from '@repo-foundation/components/CustomDialogTitle';
import { CustomDialog } from '../../components/CustomDialog';
import DataScienceGuideContent from './components/data-science/DataScienceGuideContent';
import GenerativeGuideContent from './components/generative/GenerativeGuideContent';
import SupervisedGuideContent from './components/supervised/SupervisedGuideContent';
import UnSupervisedGuideContent from './components/unsupervised/UnSupervisedGuideContent';

type AItrainContentKindKey = 'DATASCIENCE' | 'SUPERVISED' | 'UNSUPERVISED' | 'GENERATIVE';
export const AItrainContentKind: Record<AItrainContentKindKey, string> = {
  DATASCIENCE: '데이터 과학',
  SUPERVISED: '지도학습',
  UNSUPERVISED: '비지도학습',
  GENERATIVE: '생성모델',
};

const renderContent = (kind: AItrainContentKindKey) => {
  switch (kind) {
    case 'DATASCIENCE':
      return <DataScienceGuideContent />;
    case 'SUPERVISED':
      return <SupervisedGuideContent />;
    case 'UNSUPERVISED':
      return <UnSupervisedGuideContent />;
    case 'GENERATIVE':
      return <GenerativeGuideContent />;
    default:
      return undefined;
  }
};

export interface AiTrainGuideDialogProps {
  open: boolean;
  kind: AItrainContentKindKey;
  onClose: () => void;
}

export function AiTrainGuideDialog(props: AiTrainGuideDialogProps) {
  const { open, onClose, kind } = props;

  const handleDialogClose = () => {
    onClose?.();
  };

  const kindName = AItrainContentKind[kind];

  return (
    <CustomDialog
      aria-labelledby="aitrain-guide-dialog"
      open={open}
      maxWidth="sm"
      fullWidth
      onClose={handleDialogClose}
      className="AiTrainGuideDialog-root"
    >
      <CustomDialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: '1rem',
          fontWeight: 400,
          pl: {
            xs: 2,
            md: 3,
          },
          pr: 1,
          py: 0.5,
        }}
      >
        <Typography variant="h5">{`${kindName}이란?`}</Typography>
        <IconButton onClick={handleDialogClose} size="small">
          <CloseIcon />
        </IconButton>
      </CustomDialogTitle>
      <DialogContent
        dividers
        className="AiTrainGuideDialog-dialogContent"
        sx={{
          backgroundColor: '#FBFBFB',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {renderContent(kind)}
      </DialogContent>

      <DialogActions
        className="AiTrainGuideDialog-bottomBar"
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button onClick={handleDialogClose} color="primary">
          닫기
        </Button>
      </DialogActions>
    </CustomDialog>
  );
}
